import { globalFocusKey } from "@/config/focus-key";

export const localWidgetFocusKey = {
  ads: globalFocusKey.activePage + ".ads",
  skipButton: globalFocusKey.activePage + ".ads.skip-button",
};
